export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              关于女神漫画网
            </h2>
            <p className="text-foreground-500 text-sm">专注连载漫画追更服务</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-background-50 rounded-xl p-6 border border-background-200/70 text-center">
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100 mb-4">
                <i className="ri-flashlight-line text-2xl text-primary-600"></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">实时追更</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                女神漫画网追更频道实时同步各大平台连载漫画更新，确保你第一时间收到最新话推送通知，不再错过任何精彩剧情。
              </p>
            </div>
            <div className="bg-background-50 rounded-xl p-6 border border-background-200/70 text-center">
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-accent-100 mb-4">
                <i className="ri-global-line text-2xl text-accent-600"></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">多元覆盖</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                涵盖韩漫、日漫、国漫三大品类，从都市情感到奇幻冒险，从悬疑推理到热血战斗，满足不同读者的追更需求。
              </p>
            </div>
            <div className="bg-background-50 rounded-xl p-6 border border-background-200/70 text-center">
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-secondary-200 mb-4">
                <i className="ri-book-open-line text-2xl text-secondary-700"></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">免费全集</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                女神漫画网提供海量漫画免费全集在线阅读，支持下拉式沉浸追更体验，无需跳转、无需付费，畅享追更乐趣。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}